import React from "react";

function SvgGearIconNew(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.width}
      height={props.height}
      viewBox="0 0 50 50"
      color="currentColor"
    >
      <defs>
        <clipPath id="clip-Setting_1">
          <rect width="50" height="50" />
        </clipPath>
      </defs>
      <g
        id="Setting_1"
        data-name="Setting – 1"
        clipPath="url(#clip-Setting_1)"
      >
        <g id="gear" transform="translate(0.447)">
          <path
            id="Path_983"
            data-name="Path 983"
            d="M30.757,148.666a13.666,13.666,0,0,0,0-4.117l3.416-2.68a2.082,2.082,0,0,0,.515-2.66l-2.205-3.819a2.078,2.078,0,0,0-2.563-.885L25.9,136.128a13.037,13.037,0,0,0-3.554-2.056l-.612-4.3A2.076,2.076,0,0,0,19.684,128H15.278a2.076,2.076,0,0,0-2.046,1.775l-.612,4.3a13.083,13.083,0,0,0-3.538,2.052l-4.044-1.622a2.079,2.079,0,0,0-2.561.885l-2.2,3.819a2.074,2.074,0,0,0,.519,2.662L4.2,144.533a13.666,13.666,0,0,0,0,4.117L.787,151.33a2.083,2.083,0,0,0-.515,2.66l2.2,3.819a2.082,2.082,0,0,0,2.563.885l4.026-1.622a13.034,13.034,0,0,0,3.554,2.056l.612,4.3a2.079,2.079,0,0,0,2.048,1.773h4.406a2.076,2.076,0,0,0,2.046-1.775l.612-4.3a13.081,13.081,0,0,0,3.538-2.052l4.045,1.622a2.073,2.073,0,0,0,2.561-.885l2.2-3.819a2.074,2.074,0,0,0-.519-2.662Zm-13.276,5.167a7.233,7.233,0,1,1,7.233-7.233A7.241,7.241,0,0,1,17.481,153.833Zm0,0"
            transform="translate(0 -115.2)"
            fill="currentColor"
          />
          <path
            id="Path_984"
            data-name="Path 984"
            d="M319.589,11.3a7.831,7.831,0,0,0,.1-.969,7.837,7.837,0,0,0-.1-.969l1.862-1.409a1.035,1.035,0,0,0,.271-1.341L320.049,3.72a1.034,1.034,0,0,0-1.3-.436l-2.143.9a7.679,7.679,0,0,0-1.693-1.007L314.633.905A1.035,1.035,0,0,0,313.608,0h-3.342a1.033,1.033,0,0,0-1.025.905l-.285,2.275a7.709,7.709,0,0,0-1.693,1.007l-2.143-.9a1.034,1.034,0,0,0-1.3.436l-1.67,2.893a1.035,1.035,0,0,0,.271,1.341l1.862,1.409a7.425,7.425,0,0,0-.1.969,7.831,7.831,0,0,0,.1.969l-1.862,1.41a1.034,1.034,0,0,0-.271,1.341l1.672,2.893a1.034,1.034,0,0,0,1.3.436l2.143-.905a7.678,7.678,0,0,0,1.693,1.007l.285,2.275a1.035,1.035,0,0,0,1.025.907h3.342a1.033,1.033,0,0,0,1.025-.905l.285-2.275a7.722,7.722,0,0,0,1.693-1.006l2.143.9a1.034,1.034,0,0,0,1.3-.436l1.67-2.893a1.034,1.034,0,0,0-.271-1.341Zm-7.653,3.164a4.133,4.133,0,1,1,4.133-4.133A4.132,4.132,0,0,1,311.936,14.467Zm0,0"
            transform="translate(-272.307 0)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}
export default React.memo(SvgGearIconNew);
